export const handSanitizerFormFields = [
    { name: 'name', type: 'text' as const, placeholder: 'Your Name*', required: true },
    { name: 'company', type: 'text' as const, placeholder: 'Company Name*', required: true },
    { name: 'email', type: 'email' as const, placeholder: 'Company Email*', required: true },
    { name: 'phone', type: 'tel' as const, placeholder: 'Phone*', required: true },
    { 
        name: 'type', 
        type: 'select' as const, 
        placeholder: 'Type',
        options: [
            { value: 'Gel', label: 'Gel' },
            { value: 'Foam', label: 'Foam' },
            { value: 'Spray', label: 'Spray' },
            { value: 'Wipes', label: 'Wipes' }
        ]
    },
    { 
        name: 'size', 
        type: 'select' as const, 
        placeholder: 'Size',
        options: [
            { value: '2 oz', label: '2 oz' },
            { value: '8 oz', label: '8 oz' },
            { value: '16 oz', label: '16 oz' },
            { value: '1 gallon', label: '1 gallon' }
        ]
    },
    { 
        name: 'quantity', 
        type: 'select' as const, 
        placeholder: 'Quantity',
        options: [
            { value: '1-50', label: '1-50' },
            { value: '51-100', label: '51-100' },
            { value: '101-500', label: '101-500' },
            { value: '501+', label: '501+' }
        ]
    }
]; 